import { IAnalyticsProduct } from '../../types/analytics';
import { getAnalyticsBrand, getAnalyticsCategory } from '../../utils/analytics';
import { selectAnalyticsVariant } from './selectAnalyticsVariant';
import { createSelector } from 'reselect';
import { selectUser } from '../user';
import { selectOfferCategory, selectOfferId, selectPrice } from '../offer'; // Эта утилита полезна только для использования в react

export const selectAnalyticsProduct = createSelector(
  [selectUser, selectOfferCategory, selectOfferId, selectPrice, selectAnalyticsVariant],
  (user, category, id, price, variant): IAnalyticsProduct => {
    return {
      brand: getAnalyticsBrand(user),
      // тип сделки/тип объекта
      category: getAnalyticsCategory(category),
      // id объявления
      id,
      // стоимость объекта
      price: price || 0,
      // VAS
      variant,
    };
  },
);
